module.exports = __webpack_public_path__ + "0ee4da9959d5eaf353af3906aa735f97.svg";